var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.$t("SeaExport.EditSopStatus"),
        width: "735px",
        "close-on-click-modal": false
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c(
        "el-form",
        { staticStyle: { display: "flex", "flex-direction": "row" } },
        [
          _c(
            "el-form-item",
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "120px" },
                  attrs: {
                    no: "sopTemplateKey",
                    placeholder: _vm.$t("SeaExport.PleaseSelectATemplate")
                  },
                  on: { change: _vm.getTracking },
                  model: {
                    value: _vm.sopTemplateKey,
                    callback: function($$v) {
                      _vm.sopTemplateKey = $$v
                    },
                    expression: "sopTemplateKey"
                  }
                },
                _vm._l(_vm.availableSopTemplates, function(item, index) {
                  return _c("el-option", {
                    key: index,
                    attrs: { label: item.templateName, value: item.uuid }
                  })
                }),
                1
              ),
              _c(
                "el-select",
                {
                  staticStyle: { width: "120px" },
                  attrs: {
                    no: "trackingCode",
                    placeholder: _vm.$t("SeaExport.PleaseSelectANode")
                  },
                  on: { change: _vm.getTrackingDetail },
                  model: {
                    value: _vm.trackingCode,
                    callback: function($$v) {
                      _vm.trackingCode = $$v
                    },
                    expression: "trackingCode"
                  }
                },
                _vm._l(_vm.availableTrackingList, function(item, index) {
                  return _c("el-option", {
                    key: index,
                    attrs: { label: item.codeCname, value: item.code }
                  })
                }),
                1
              ),
              _c(
                "el-select",
                {
                  staticStyle: { width: "140px" },
                  attrs: {
                    no: "trackingDetailCode",
                    placeholder: _vm.$t("SeaExport.PleaseSelectAState")
                  },
                  model: {
                    value: _vm.trackingDetailCode,
                    callback: function($$v) {
                      _vm.trackingDetailCode = $$v
                    },
                    expression: "trackingDetailCode"
                  }
                },
                _vm._l(_vm.trackingDetailList, function(item, index) {
                  return _c("el-option", {
                    key: index,
                    attrs: { label: item.codeCname, value: item.code }
                  })
                }),
                1
              ),
              _c("el-date-picker", {
                staticStyle: { width: "180px" },
                attrs: {
                  value: _vm.trackingDetailDate || new Date(),
                  type: "datetime",
                  "value-format": "yyyy-MM-dd HH:mm",
                  format: "yyyy-MM-dd HH:mm",
                  placeholder: _vm.$t("SeaExport.SelectTime")
                },
                on: {
                  input: function(val) {
                    _vm.trackingDetailDate = val
                  }
                }
              }),
              _c("el-input", {
                staticStyle: { width: "150px" },
                model: {
                  value: _vm.trackingDetailRemark,
                  callback: function($$v) {
                    _vm.trackingDetailRemark = $$v
                  },
                  expression: "trackingDetailRemark"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c("div", { staticStyle: { display: "flex" } }, [
        _c(
          "div",
          { staticStyle: { display: "flex", "flex-direction": "column" } },
          [
            _c(
              "el-checkbox",
              {
                model: {
                  value: _vm.messageChecked,
                  callback: function($$v) {
                    _vm.messageChecked = $$v
                  },
                  expression: "messageChecked"
                }
              },
              [_vm._v(_vm._s(_vm.$t("Message.SendStatusChangeNotification")))]
            )
          ],
          1
        ),
        _c(
          "div",
          {
            staticStyle: {
              display: "flex",
              "flex-direction": "column",
              "padding-left": "10px"
            }
          },
          [
            _c("span", { staticStyle: { "padding-top": "2.5px" } }, [
              _vm._v(_vm._s("*" + _vm.$t("Message.OptionIsChecked")))
            ])
          ]
        )
      ]),
      _c(
        "div",
        {
          staticStyle: { margin: "0 auto", width: "fit-content" },
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            {
              attrs: { no: "confirm", type: "primary" },
              on: { click: _vm.confirmEditState }
            },
            [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
          ),
          _c(
            "el-button",
            {
              attrs: { no: "cancel" },
              on: {
                click: function($event) {
                  _vm.innerVisible = false
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }